export default {
  en: {
    placeholder: 'Enter a number',
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    orMore: '{0} or more',
    require: 'Require at least',
    requireCol: 'At least {n}',
    requireHeading: 'At least',
    notRequired: 'Not required',
    outOfScope: 'Out of scope',
    answer: 'Answer',
    answered: 'Answered',
    youAnswered: 'You answered',
    editAnswer: 'Edit answer',
    lastModified: 'Last modified {0}',
    dateFormat: 'YYYY/MM/DD',
  },
};
